import React from "react";

const REASONS = [
  "You're tired of pushing, proving and holding it all together.",
  "You've achieved a lot, yet a part of you still feels exhausted and unfulfilled.",
  "You sense there is a softer, more spacious way to live and lead.",
  "You're ready to stop chasing freedom and start embodying it.",
  "You want to align your life with who you really are, not who you've been performing as.",
  "You know that something has to change, and you're ready for that change to be inward.",
];

const WhoFor = () => {
  return (
    <section
      className="py-24 md:py-36 bg-champagne relative overflow-hidden"
      data-testid="who-section"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="text-center fade-up">
          <p className="eyebrow">For You</p>
          <h2
            className="mt-6 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight balance"
            style={{ color: "var(--ink)" }}
            data-testid="who-headline"
          >
            This masterclass is for you{" "}
            <em style={{ color: "var(--gold-deep)" }}>if…</em>
          </h2>
        </div>

        <ul className="mt-16 md:mt-20 max-w-3xl mx-auto space-y-7">
          {REASONS.map((reason, i) => (
            <li
              key={i}
              className="flex items-start gap-5 fade-up"
              style={{ animationDelay: `${i * 90}ms` }}
              data-testid={`who-reason-${i + 1}`}
            >
              <svg
                className="flex-shrink-0 mt-2"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M12 2 L13.2 9.5 L20.5 10.5 L14.5 14.5 L16.5 22 L12 17.5 L7.5 22 L9.5 14.5 L3.5 10.5 L10.8 9.5 Z"
                  fill="var(--gold-deep)"
                />
              </svg>
              <p
                className="font-serif leading-snug pretty"
                style={{ color: "var(--ink)", fontSize: "1.5rem" }}
              >
                {reason}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default WhoFor;
